/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";

import { assetImages } from "constants";
import downloadFileHandler from "helper/DownloadFile";

const CrmLeadInformationLeftPanel = ({
  setnoteAccessUserList = () => {},
  setleadName,
  setleadImage,
  setisValidUser,
  setShowAlert,
  setAlertMessage,
  setMessageType,
  setLeadLoading = () => {},
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const params = useParams();

  const [sourceName, setSourceName] = useState("");
  const [sourceUrl, setsourceUrl] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [emailAddress, setemailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [company, setcompany] = useState("");
  const [position, setposition] = useState("");
  const [resumeTitle, setresumeTitle] = useState("");
  const [resumeSummary, setresumeSummary] = useState("");
  const [resumeDetails, setresumeDetails] = useState("");
  const [minSalary, setminSalary] = useState("");
  const [maxSalary, setmaxSalary] = useState("");
  const [paymentDuration, setpaymentDuration] = useState("");
  const [educations, setEducations] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [skillPoints, setSkillPoints] = useState([]);
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [uploadedVideos, setUploadedVideos] = useState([]);
  const [skills, setSkills] = useState([]);
  const [skillStrings, setskillStrings] = useState("");
  const [followers, setFollowers] = useState([]);
  const [customerMessage, setCustomerMessage] = useState("");
  const [lastContactDate, setLastContactDate] = useState("");
  const [lastContactSubject, setLastContactSubject] = useState("");
  const [lastContactChannel, setLastContactChannel] = useState("");
  const [lastResponseDate, setLastResponseDate] = useState("");
  const [lastResponseSubject, setLastResponseSubject] = useState("");
  const [lastResponseChannel, setLastResponseChannel] = useState("");
  const [lastTransaction, setlastTransaction] = useState("");
  const [transactionModule, settransactionModule] = useState("");
  const [transactionElement, settransactionElement] = useState("");
  const [transactionAmount, settransactionAmount] = useState("");
  const [transactionDate, settransactionDate] = useState("");
  const [industryValue, setIndustryValue] = useState("");
  const [interestValue, setInterestValue] = useState("");
  const [createdAt, setcreatedAt] = useState("");
  const [updatedAt, setupdatedAt] = useState("");

  //for check the user is authenticated or not
  const [isAuthenticatedUser, setisAuthenticatedUser] = useState(false);

  //function for get lead details
  const getLeadDetails = async () => {
    try {
      setLeadLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LEAD_DETAILS +
        `/${params.id}?token=${token}`;

      console.log("url of lead details------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response of lead details------>", response);

      if (response.status) {
        if (
          response.data.moderator &&
          response.data.moderator._id.toString() === userInfo._id.toString()
        ) {
          setisAuthenticatedUser(true);
          setisValidUser(true);
        } else {
          setisAuthenticatedUser(false);
          setisValidUser(false);
        }

        setSourceName(response.data.source);
        setsourceUrl(response.data.sourceurl);

        const respondedLeadName = response.data.name
          ? `${response.data.name ?? ""} ${response.data.surname ?? ""}`
          : `${response.data.email}`;

        setleadName(respondedLeadName);

        if (response.data?.photoimage) {
          setleadImage(response.data?.photoimage?.path);
        } else {
          setleadImage("");
        }

        setfirstName(response.data.name);
        setlastName(response.data.surname);
        setemailAddress(response.data.email);
        setPhoneNumber(response.data.phone);
        setFollowers(response.data.followerslist);

        if (response.data.dob) {
          if (response.data.dob.includes("-")) {
            let components = response.data.dob.split("-");
            let year = components[0];
            let month = components[1];
            let day = components[2];
            let newDate = day ?? "" + "-" + month ?? "" + "-" + year ?? "";
            setDateOfBirth(newDate);
          }
        } else {
          setDateOfBirth("");
        }

        setcompany(response.data.company);
        setposition(response.data.position);
        setCustomerMessage(response.data.customercomment);
        setresumeTitle(response.data.resumetitle);
        setresumeSummary(response.data.resumesummary);
        setresumeDetails(response.data.resumedetails);
        setminSalary(response.data.minsalary);
        setmaxSalary(response.data.maxsalary);
        setpaymentDuration(response.data.paymentduration);
        setEducations(response.data.educationids);
        setExperiences(response.data.experienceids);
        setSkillPoints(response.data.skillpointids);
        setUploadedDocs(response.data.uploadeddocresume);
        setUploadedVideos(response.data.uploadedvideoresume);
        setSkills(response.data.skills);
        setskillStrings(response.data.skillsstring);
        setLastContactChannel(response.data.lastcontactchannel);
        setLastContactDate(response.data.lastcontactdate);
        setLastContactSubject(response.data.lastcontactsubject);
        setLastResponseChannel(response.data.lastresponsechannel);
        setLastResponseDate(response.data.lastresponsedate);
        setLastResponseSubject(response.data.lastresponsesubject);
        setlastTransaction(response.data.transactionid);
        settransactionModule(response.data.module);
        settransactionElement(response.data.element);
        settransactionDate(response.data.transactiondate);
        settransactionAmount(response.data.transactionamount);
        setIndustryValue(response.data.industry);
        setInterestValue(response.data.interest);

        // Format createdAt and updatedAt
        function formatDateTime(dt) {
          if (!dt) return "";
          const d = new Date(dt);
          if (isNaN(d.getTime())) return dt;
          const pad = (n) => n.toString().padStart(2, "0");
          return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        }

        setcreatedAt(formatDateTime(response.data.createdAt));
        setupdatedAt(formatDateTime(response.data.updatedAt));

        const allFollowerIds = response.data.followers
          ? response.data.followers.map((item) => item._id)
          : [];

        const appendedNoteFollowers = [...allFollowerIds];

        if (response.data.moderator) {
          appendedNoteFollowers.push(response.data.moderator._id);
        }

        const filterNoteFollowers = appendedNoteFollowers.filter(
          (item) => item.toString() !== userInfo._id.toString(),
        );

        setnoteAccessUserList(filterNoteFollowers);

        setMessageType("success");
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowAlert(true);
      setLeadLoading(false);
    }
  };

  useEffect(() => {
    if (params.id) {
      getLeadDetails();
    }
  }, [params.id]);

  return (
    <div className="p-4 border border-gray-300 rounded-10 shadow-sm">
      {/* ===== Main Information Block ===== */}
      {/* Block 1: Main Information */}
      <div className="main-info-block p-4 border rounded-10 mb-4">
        <div className="text-muted small mb-2">{t("Basic Information")}</div>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <p className="name fw-bold mb-1 fs-lg">
              {firstName} {lastName}
            </p>
            <ul className="d-flex flex-wrap gap-3 fs-md mb-0">
              <li>
                <Link to="#" className="d-flex align-items-center gap-1">
                  <span className="d-block material-symbols-outlined icon-sm">
                    email
                  </span>
                  <span className="d-block">{emailAddress}</span>
                </Link>
              </li>
              <li className={phoneNumber === "" ? "d-none" : ""}>
                <Link to="#" className="d-flex align-items-center gap-1">
                  <span className="d-block material-symbols-outlined icon-sm">
                    phone_in_talk
                  </span>
                  <span className="d-block">{phoneNumber}</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* ---- edit link section top right ----- */}
          {(userInfo.role.slug === "ADMIN" ||
            userInfo.role.slug === "SUPER_ADMIN" ||
            isAuthenticatedUser) && (
            <Link
              to={`/admin/crm/lead/save/${params.id}`}
              className="d-inline-flex align-items-center gap-2 px-4 btn btn-gray border-secondary"
            >
              <span className="d-block material-symbols-outlined icon-sm">
                edit
              </span>
              <span className="d-block">{t("Edit")}</span>
            </Link>
          )}
        </div>

        <p>
          <b>{t("Company")}:</b> {company}
        </p>
        <p>
          <b>{t("Position")}:</b> {position}
        </p>
        <p>
          <b>{t("Interest")}:</b>{" "}
          {Array.isArray(interestValue)
            ? interestValue.filter(Boolean).join(", ")
            : interestValue || ""}
        </p>
        <p>
          <b>{t("Industry")}:</b>{" "}
          {Array.isArray(industryValue)
            ? industryValue.filter(Boolean).join(", ")
            : industryValue || ""}
        </p>
        <p>
          <b>{t("Source")}:</b>{" "}
          {sourceName || sourceUrl
            ? `${sourceName} ${sourceUrl}`.trim()
            : t("Lead Form Submit")}
        </p>

        <p>
          <b>{t("Created Date")}:</b> {createdAt ?? ""}
        </p>
        <p>
          <b>{t("Last Updated")}:</b> {updatedAt ?? ""}
        </p>
      </div>
      {/* ===== End Main Information Block ===== */}

      {/* ===== CV Block ===== */}
      {/* Block 2: CV Block */}
      <div className="cv-block p-4 border rounded-10 mb-4">
        <div className="text-muted small mb-2">
          {t("Education and Experiences")}
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">{t("Resume Title")}</h3>
          {(userInfo.role.slug === "ADMIN" ||
            userInfo.role.slug === "SUPER_ADMIN" ||
            isAuthenticatedUser) && (
            <Link
              to={`/admin/crm/lead/cvbuilder/${params.id}`}
              className="d-inline-flex align-items-center gap-2 px-4 btn btn-outline-primary"
            >
              <span className="d-block">{t("Add your CV")}</span>
            </Link>
          )}
        </div>
        <p>{resumeTitle}</p>
        <h3>{t("Resume Summary")}</h3>
        <p>{resumeSummary}</p>
        <h3>{t("Resume Details")}</h3>
        <p dangerouslySetInnerHTML={{ __html: resumeDetails }}></p>
        <h3>{t("Pay Rate")}</h3>
        <p>
          <span className="text-muted">{t("Min Salary")}:</span>{" "}
          {minSalary || <span className="text-muted">N/A</span>}{" "}
          <span className="text-muted ms-2">{t("Max Salary")}:</span>{" "}
          {maxSalary || <span className="text-muted">N/A</span>}{" "}
          <span className="text-muted ms-2">{t("Duration")}:</span>{" "}
          {paymentDuration || <span className="text-muted">N/A</span>}
        </p>
        <h3>{t("Skill Points")}</h3>
        {skillPoints.map((skillPoint, index) => (
          <p key={index}>
            {index + 1}. Skill name : {skillPoint?.skillname} , Point :{" "}
            {skillPoint?.points}
          </p>
        ))}
        <h3>{t("Education")}</h3>
        {educations.map((education, index) => (
          <p key={index}>
            {index + 1}. Completed {education?.degree} from{" "}
            {education?.institute} on {education?.year}
          </p>
        ))}
        <h3>{t("Experience")}</h3>
        {experiences.map((experience, index) => (
          <p key={index}>
            {index + 1}. {experience?.position} at {experience?.company} <br />
            Working from {experience?.start} to {experience?.end}
          </p>
        ))}
      </div>
      {/* ===== End CV Block ===== */}

      {/* ===== Last Contact Info Block ===== */}
      {/* Block 3: Last Contact Info */}
      <div className="last-contact-block p-4 border rounded-10 mb-4">
        <div className="text-muted small mb-2">{t("Connect History")}</div>
        <h3>{t("Last Response Date")}</h3>
        <p>{lastResponseDate}</p>
        <h3>{t("Last Response Subject")}</h3>
        <p>{lastResponseSubject}</p>
        <h3>{t("Last Response Channel")}</h3>
        <p>{lastResponseChannel}</p>
        <h3>{t("Last Transaction")}</h3>
        <p>{lastTransaction}</p>
        <h3>{t("Transaction Module")}</h3>
        <p>{transactionModule}</p>
        <h3>{t("Transaction Element")}</h3>
        <p>{transactionElement}</p>
        <h3>{t("Transaction Amount")}</h3>
        <p>{transactionAmount}</p>
        <h3>{t("Transaction Date")}</h3>
        <p>{transactionDate}</p>
      </div>
      {/* ===== End Last Contact Info Block ===== */}

      {/* ===== Attachments Block ===== */}
      {/* Block 4: Attachments */}
      <div className="attachments-block p-4 border rounded-10 mb-4">
        <div className="text-muted small mb-2">{t("Attachments")}</div>
        <ul className="documents d-flex flex-wrap gap-3 mb-4">
          {uploadedDocs.map((docFile, index) => (
            <li
              key={index}
              className="document d-flex align-items-center px-3 py-2 body-bg rounded-10"
            >
              <img
                src={
                  docFile.path.split(".").pop() == "pdf"
                    ? assetImages.PdfImg
                    : docFile.path.split(".").pop() == "xlsx"
                      ? assetImages.XlsImg
                      : assetImages.DocImg
                }
                alt={docFile.name}
                className="img-fluid me-2"
              />
              <span className="d-block fw-medium me-4">{docFile.name}</span>
              <Link to="#" onClick={() => downloadFileHandler(docFile)}>
                <span className="d-block material-symbols-outlined icon-lg">
                  download
                </span>
              </Link>
            </li>
          ))}
        </ul>
        <div className="videos row">
          {uploadedVideos.map((video, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="video-container bg-white p-2 rounded-10 shadow-sm">
                <div className="ratio ratio-16x9 rounded-8 bg-cover bg-center bg-norepeat">
                  <video src={video.path} controls></video>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* ===== End Attachments Block ===== */}
    </div>
  );
};

export default CrmLeadInformationLeftPanel;
